import React, { useState, useRef, useEffect } from 'react';
import '../../css/custom-select.css';

const CustomSelect = ({
  options,
  placeholder = 'Выберите опцию',
  value,
  onChange,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value) || null;

  const handleSelect = (option) => {
    onChange(option.value);
    setShowOptions(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showOptions]);

  return (
    <div className="custom-select" ref={selectRef}>
      <div className={`select-box${selectedOption ? ' selected' : ''}`} onClick={() => setShowOptions(!showOptions)}>
        {selectedOption ? selectedOption.label : placeholder}
      </div>
      <div className={`options ${showOptions ? 'show' : ''}`}>
        {options.map((option) => (
          <div
            key={option.value}
            className="option"
            onClick={() => handleSelect(option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSelect;